import React from "react";
import { Section } from "../section";
import { __ } from "@wordpress/i18n";
import {
  ServerIcon,
  ArrowIcon,
  SettingsIcon,
  GlobeIcon,
  LayersIcon,
  EmailIcon,
  SupportIcon,
} from "../../icons";
import { getUtmUrl } from "../../utils/utm-url";

const FEATURES = [
  {
    icon: ServerIcon,
    title: __("Fully managed hosting", "plugin-cross-sell-textdomain"),
    description: __(
      "Deliver lightning-fast, secure websites with a 99.9% SLA—complete with isolated environments, global server locations, and expert support.",
      "plugin-cross-sell-textdomain"
    ),
    link: getUtmUrl("https://wpmudev.com/hosting/", {utm_campaign:'cross-sell_service_hosting'}),
  },
  {
    icon: SettingsIcon,
    title: __("Site management", "plugin-cross-sell-textdomain"),
    description: __(
      "Take command of all your WordPress sites with one simple dashboard to automate updates, monitor performance, and generate white-label client reports.",
      "plugin-cross-sell-textdomain"
    ),
    link: getUtmUrl("https://wpmudev.com/site-management/", {utm_campaign:'cross-sell_service_hub'}),
  },
  {
    icon: GlobeIcon,
    title: __("Domains", "plugin-cross-sell-textdomain"),
    description: __(
      "With access to over 250 TLDs, seamless integration and free privacy protection, you can offer domain registration services at unbeatable prices.",
      "plugin-cross-sell-textdomain"
    ),
    link: getUtmUrl("https://wpmudev.com/domains/", {utm_campaign:'cross-sell_service_domains'}),
  },
  {
    icon: LayersIcon,
    title: __("100+ template library", "plugin-cross-sell-textdomain"),
    description: __(
      "Create beautiful sites in seconds with pre-configured site templates for you and your client projects—compatible with every plugin, theme builder and tool.",
      "plugin-cross-sell-textdomain"
    ),
    link: getUtmUrl("https://wpmudev.com/site-templates/", {utm_campaign:'cross-sell_service_templates'}),
  },
  {
    icon: EmailIcon,
    title: __("Get Pro Email", "plugin-cross-sell-textdomain"),
    description: __(
      "Add-on private, ad-free IMAP webmail for easily managed, auto-synced, professional emails for you and your clients with 5-50GB storage options.",
      "plugin-cross-sell-textdomain"
    ),
    link: getUtmUrl("https://wpmudev.com/webmail/", {utm_campaign:'cross-sell_service_email'}),
  },
  {
    icon: SupportIcon,
    title: __("Unparalleled support", "plugin-cross-sell-textdomain"),
    description: __(
      "Chat with our support team anytime—24/7, 365 days a year—with an average response time of 2 minutes. We’ll even log in and fix issues for you and your clients!",
      "plugin-cross-sell-textdomain"
    ),
    link: getUtmUrl("https://wpmudev.com/get-support/", {utm_campaign:'cross-sell_service_support'}),
  },
];

const Features = () => {
  return (
    <Section
      title={__(
        "Everything you need to grow a successful agency - at an unrivaled value",
        "plugin-cross-sell-textdomain"
      )}
    >
      {FEATURES.length > 0 && (
        <div className="cross-sell-features cross-sell-grid">
          {FEATURES.map((feature) => (
            <a
              className="cross-sell-card"
              key={feature.title}
              href={feature.link}
              target="_blank"
            >
              <div className="cross-sell-feature-header">
                <feature.icon />
                <h3>{feature.title}</h3>
                <ArrowIcon className="cross-sell-feature-arrow" />
              </div>
              <p>{feature.description}</p>
            </a>
          ))}
        </div>
      )}
    </Section>
  );
};

export { Features };
